/**
 * External dependencies
 */
import { Component } from 'react'
import { range } from '~bookwormgb/util/range'

class BlogPostPlaceholder extends Component {

	render() {
		const {
			postsToShow,
			mdColumns,
			lgColumns,
			showPostFeaturedImage,
			showPostDate,
			showPostComments,
			showPostTitle,
		} = this.props

		const output = (
			<ul className={ `blog-posts-placeholder blog-posts list-unstyled my-0 row row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns }` }>
				{ range( 1, postsToShow + 1 ).map( i => {
					return(
						<li className="blog-post col mb-4" key={ `blog-${i}` }>
							{ showPostFeaturedImage &&
								<div className="rounded-md mb-3 bg-animation" style={ { height:'280px' } }></div>
							}
							{ ( showPostDate || showPostComments ) &&
								<div className="w-60 rounded-pill mb-2 bg-animation" style={ { height:'25px' } }></div>
							}
							{ showPostTitle &&
								<div className="w-100 rounded-pill bg-animation" style={ { height:'25px' } }></div>
							}
						</li>
					)
				} ) }
			</ul>
		)

		return output
	}
}

export default BlogPostPlaceholder